import { QueryState } from '@/common/enum';
import { Nullable } from 'interfaces/Nullable.ts';

export type RegisterStateTypes = {
  queryState: QueryState;
  error: Nullable<string>;
};

export const RegisterInitialState: RegisterStateTypes = {
  queryState: QueryState.UNDEFINED,
  error: null,
};
